<div class="audit-sync-actions">
  <div class="audit-sync-actions__header">
    <pr-icon name="lock" [width]="18" [height]="18"></pr-icon>
    <span class="audit-sync-actions__title">Montants repris de l’audit du client</span>
  </div>
  <p class="audit-sync-actions__text">Ils ne se modifient pas ici. Pour les corriger :</p>
  <ol class="audit-sync-actions__steps">
    <li class="audit-sync-actions__step">
      <span class="audit-sync-actions__number">1</span>
      <span class="audit-sync-actions__label">
        Modifiez l’audit
        <span class="audit-sync-actions__hint">s’ouvre dans un nouvel onglet</span>
      </span>
      <pr-button
        display="neutral"
        variant="outline"
        icon="open_in_new"
        label="Ouvrir l’audit"
        (onClick)="openAudit()"
      ></pr-button>
    </li>
    <li class="audit-sync-actions__step">
      <span class="audit-sync-actions__number">2</span>
      <span class="audit-sync-actions__label">
        Revenez ici et synchronisez les montants
        <span class="audit-sync-actions__hint">l’impôt et l’IFI sont aussi recalculés</span>
      </span>
      <pr-button display="neutral" icon="sync" label="Resynchroniser" [disabled]="resyncing" (onClick)="resync()"></pr-button>
    </li>
  </ol>
</div>
